<template>
  <button
    :type="btnType"
    class="sm-btn"
    :class="computedClasses" 
    @click.stop="$emit('click')"
  >
    <include-svg v-if="icon" :name="icon" />
    <span>
      {{ text }}
    </span>
    <span
      v-if="hints > 0"
      class="sm-btn__hint"
    >{{hints}}</span>
  </button>
</template>

<script>
export default {
    name: 'btn-block',
    data() {
      return {
        btnType: 'button'
      }
    },
    props: {
      type: {
        type: String,
        default: 'base'
      },
      classes: {
        type: Array,
        default: () => []
      },
      text: String,
      icon: {
        type: String,
        default: null
      },
      hints: {
        type: Number,
        default: 0
      }
    },
    created() {
      this.btnType = this.type === 'submit' ? 'submit' : 'button';
    },
    computed: {
      typeClass() {
        return this.type !== 'base' ? `sm-btn--${this.type}` : '';
      },
      computedClasses() {
        return [...this.classes, this.typeClass];
      }
    }
}
</script>